import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const proformaIssueFormsGeneralRoute: InvariantJiraRoute = {
	name: 'proforma-issue-forms-general',
	path: '/jira/forms/create',
	exact: true,
};
